/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useState } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { UseParamsType } from "../../../../../../../utils/useParams"
import { SchedulesAddStateProps } from "../../../../models/add"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { getBreadcrumbItems } from "./getBreadcrumbItems"
import { getGeneralMasters } from "../../../../../../../utils/apis/getGeneralMasters"
import { getAllCountries } from "../../../../../../../utils/apis/getAllCountries"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { useHandle } from "../useHandle"
import { useModal } from "../../../../../../../utils/hook/useModal"
import { TravelersDetailDataType } from "../../../../../travelers/models/detail/data"
import { TravelerInfoResponseType } from "../../../../components/add/Form/ContentCollapse/Personal/models"

const { TPTT } = GeneralCode

export const useVariables = () => {
  const { pathname, state } = useLocation<SchedulesAddStateProps>()
  const { push } = useHistory()
  const { id } = useParams<UseParamsType>()
  const {
    isOpen: isOpenExportScheduleDraft,
    onCancel: onCancelExportScheduleDraft,
    onOpen: onOpenExportScheduleDraft,
  } = useModal()
  const {
    isOpen: isOpenScheduleDraft,
    onCancel: onCancelScheduleDraft,
    onOpen: onOpenScheduleDraft,
  } = useModal()
  const {
    isOpen: isOpenPopup,
    onCancel: onCancelPopup,
    onOpen: onOpenPopup,
  } = useModal()

  const {
    isFromSCR212,
    isNotAccessScreen,
    isSchedulesAdd,
    isSchedulesEdit,
    isVisibleBtn,
    isVisibleBtnCancel,
    isVisibleBtnConfirm,
    isVisibleBtnCopy,
    isVisibleOtherRemarks,
  } = useVariablesAuthority(pathname, id)

  const [isLoadingLayout, setIsLoadingLayout] = useState(true)
  const [isHiddenBtnScheduleDraft, setIsHiddenBtnScheduleDraft] = useState(true)
  const [travelerDetail, setTravelerDetail] =
    useState<TravelersDetailDataType>()
  const [travelerBase, setTravelerBase] = useState<TravelerInfoResponseType>()

  // APIを呼び出し、交通手段一覧情報を取得し
  const { generalMasters: transportationList } = getGeneralMasters(TPTT)

  // APIを呼び出し、国一覧情報を取得し
  const { allCountries } = getAllCountries()

  const {
    assignmentValidMsg,
    dataSubmit,
    defaultActiveKey,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexIdentity,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    dispatchType,
    dispatchTypeDetailRes,
    form,
    getFlightInfo,
    getInitialValues,
    getPurposeTravelList,
    goToSchedulesClone,
    handleAddDetailItem,
    handleAddLodgingItem,
    handleAddStayItem,
    handleCheckHiredLocally,
    handleCheckInsuranceAndUrgent,
    handleCheckSubmitValidate,
    handleCheckTwoWay,
    handleDeleteDetailItem,
    handleDeleteLodgingItem,
    handleDeleteStayItem,
    handleError,
    handleErrorValidate,
    handleSetDetailRequiredFields,
    handleSetLodgingRequiredFields,
    handleSetStayRequiredFields,
    isAccompanyingFamily,
    isActiveBumon,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isOpen,
    isOpenRoundTrip,
    isOtherStaffNumber,
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableDetails,
    isRequiredItemTableLodgings,
    isSubmitValidate,
    isTwoWay,
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    lodgingColumns,
    lodgingDataSource,
    lodgingIndexIdentity,
    lodgingIndexTabActive,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingTabsItems,
    lodgingValidMsg,
    onBlur,
    onCancel,
    onCancelRoundTrip,
    onChangeCollapse,
    onChangeDate,
    onChangeDifferentInfo,
    onChangeTravelPurpose,
    onClickDetailTab,
    onClickLodgingTab,
    onClickStayTab,
    onDispatchTypeDetailChange,
    onFinish,
    onKeyDown,
    onOkRoundTrip,
    onValidateChangeDate,
    onValuesChange,
    purposeTravelList,
    scheduleDetails,
    scheduleLodgings,
    schedulesData,
    scheduleStays,
    setAssignmentValidMsg,
    setDataScheduleDetails,
    setDataScheduleLodgings,
    setDataScheduleStays,
    setDefaultCountries,
    setDepartments,
    setDetailDataSource,
    setDetailValidMsg,
    setDispatchType,
    setDispatchTypeDetailRes,
    setIsAccompanyingFamily,
    setIsActiveBumon,
    setIsDifferentInfoChecked,
    setIsOtherStaffNumber,
    setIsRequiredItemTableByPPTV,
    setIsRequiredItemTableLodgings,
    setIsTwoWay,
    setLodgingDataSource,
    setLodgingValidMsg,
    setPurposeTravelRes,
    setSchedulesData,
    setStayDataSource,
    setTravelerBumonCd,
    setTravelerId,
    setWorkPlaceCountryCode,
    setWorkPlaceLocation,
    stayColumns,
    stayDataSource,
    stayIndexIdentity,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
    travelerBumonCd,
    travelerId,
  } = useHandle(isVisibleBtn)

  const breadcrumbItems = getBreadcrumbItems(
    id,
    !!state?.isFromSCR114UserSearch,
    pathname,
  )

  const isValidForm =
    !!detailDataSource.length &&
    !!lodgingDataSource.length &&
    !!stayDataSource.length

  return {
    allCountries,
    assignmentValidMsg,
    breadcrumbItems,
    dataSubmit,
    defaultActiveKey,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexIdentity,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    dispatchType,
    dispatchTypeDetailRes,
    form,
    getFlightInfo,
    getInitialValues,
    getPurposeTravelList,
    goToSchedulesClone,
    handleAddDetailItem,
    handleAddLodgingItem,
    handleAddStayItem,
    handleCheckHiredLocally,
    handleCheckInsuranceAndUrgent,
    handleCheckSubmitValidate,
    handleCheckTwoWay,
    handleDeleteDetailItem,
    handleDeleteLodgingItem,
    handleDeleteStayItem,
    handleError,
    handleErrorValidate,
    handleSetDetailRequiredFields,
    handleSetLodgingRequiredFields,
    handleSetStayRequiredFields,
    id,
    isAccompanyingFamily,
    isActiveBumon,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isFromSCR212,
    isHiddenBtnScheduleDraft,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOpenExportScheduleDraft,
    isOpenPopup,
    isOpenRoundTrip,
    isOpenScheduleDraft,
    isOtherStaffNumber,
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableDetails,
    isRequiredItemTableLodgings,
    isSchedulesAdd,
    isSchedulesEdit,
    isSubmitValidate,
    isTwoWay,
    isValidForm,
    isVisibleBtn,
    isVisibleBtnCancel,
    isVisibleBtnConfirm,
    isVisibleBtnCopy,
    isVisibleOtherRemarks,
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    lodgingColumns,
    lodgingDataSource,
    lodgingIndexIdentity,
    lodgingIndexTabActive,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingTabsItems,
    lodgingValidMsg,
    onBlur,
    onCancel,
    onCancelExportScheduleDraft,
    onCancelPopup,
    onCancelRoundTrip,
    onCancelScheduleDraft,
    onChangeCollapse,
    onChangeDate,
    onChangeDifferentInfo,
    onChangeTravelPurpose,
    onClickDetailTab,
    onClickLodgingTab,
    onClickStayTab,
    onDispatchTypeDetailChange,
    onFinish,
    onKeyDown,
    onOkRoundTrip,
    onOpenExportScheduleDraft,
    onOpenPopup,
    onOpenScheduleDraft,
    onValidateChangeDate,
    onValuesChange,
    pathname,
    purposeTravelList,
    push,
    scheduleDetails,
    scheduleLodgings,
    scheduleStays,
    schedulesData,
    setAssignmentValidMsg,
    setDataScheduleDetails,
    setDataScheduleLodgings,
    setDataScheduleStays,
    setDefaultCountries,
    setDepartments,
    setDetailDataSource,
    setDetailValidMsg,
    setDispatchType,
    setDispatchTypeDetailRes,
    setIsAccompanyingFamily,
    setIsActiveBumon,
    setIsDifferentInfoChecked,
    setIsHiddenBtnScheduleDraft,
    setIsLoadingLayout,
    setIsOtherStaffNumber,
    setIsRequiredItemTableByPPTV,
    setIsRequiredItemTableLodgings,
    setIsTwoWay,
    setLodgingDataSource,
    setLodgingValidMsg,
    setPurposeTravelRes,
    setSchedulesData,
    setStayDataSource,
    setTravelerBase,
    setTravelerBumonCd,
    setTravelerDetail,
    setTravelerId,
    setWorkPlaceCountryCode,
    setWorkPlaceLocation,
    state,
    stayColumns,
    stayDataSource,
    stayIndexIdentity,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
    transportationList,
    travelerBase,
    travelerBumonCd,
    travelerDetail,
    travelerId,
  }
}
